import { ConnectIDLottie } from "./ConnectIDLottie";

interface ConnectIDPhoneFrameProps {
  className?: string;
  variant?: "realistic" | "simple";
  "data-testid"?: string;
}

export function ConnectIDPhoneFrame({
  className = "",
  variant = "realistic",
  "data-testid": dataTestId = "connectid-phone-frame",
}: ConnectIDPhoneFrameProps) {
  if (variant === "simple") {
    return (
      <div
        className={`rounded-[2rem] border border-[hsl(var(--brand-sand))] bg-[hsl(var(--brand-bone))] p-[7px] shadow-2xl ${className}`}
        data-testid={dataTestId}
      >
        <ConnectIDLottie className="aspect-[402/874] rounded-[1.6rem] bg-white" />
      </div>
    );
  }

  return (
    <div
      className={`relative rounded-[2.65rem] border-[3px] border-[#0b0b0c] bg-gradient-to-br from-[#73767b] via-[#1c1d20] to-[#4a4c51] p-[5px] shadow-[0_22px_45px_-18px_rgba(0,0,0,0.7)] ${className}`}
      data-testid={dataTestId}
    >
      {/* Physical side buttons */}
      <span className="absolute -left-[5px] top-[19%] h-[7%] w-[3px] rounded-l-sm border border-[#101114] bg-gradient-to-r from-[#36383c] to-[#85878b]" />
      <span className="absolute -left-[5px] top-[29%] h-[11%] w-[3px] rounded-l-sm border border-[#101114] bg-gradient-to-r from-[#36383c] to-[#85878b]" />
      <span className="absolute -left-[5px] top-[42%] h-[11%] w-[3px] rounded-l-sm border border-[#101114] bg-gradient-to-r from-[#36383c] to-[#85878b]" />
      <span className="absolute -right-[5px] top-[31%] h-[13%] w-[3px] rounded-r-sm border border-[#101114] bg-gradient-to-l from-[#36383c] to-[#85878b]" />

      <div className="relative overflow-hidden rounded-[2.25rem] border border-[#080809] bg-[#050505] p-[2px]">
        <div className="relative overflow-hidden rounded-[2rem] bg-white">
          <ConnectIDLottie className="aspect-[402/874] bg-white" />

          {/* Dynamic Island with camera and earpiece detail */}
          <div className="pointer-events-none absolute left-1/2 top-[7px] z-10 flex h-[14px] w-[36%] -translate-x-1/2 items-center justify-end rounded-full bg-[#050505] px-[5px] shadow-[inset_0_0_2px_rgba(255,255,255,0.15)]">
            <span className="h-[4px] w-[4px] rounded-full bg-[#15171b] ring-1 ring-[#24262b]" />
          </div>

          {/* Soft glass reflection */}
          <div className="pointer-events-none absolute inset-0 z-20 bg-gradient-to-br from-white/10 via-transparent to-transparent" />
        </div>
      </div>
    </div>
  );
}